import { api } from '../../../shared/api/client';
import {
  type ListEnvelope,
  normalizeListEnvelope,
  toGenexusParams,
} from '../../../shared/api/genexus-query';
import type { CrudApi } from '../../../shared/api/crud-hooks';
import type { DataTableQuery } from '../../../shared/components/DataTable';
import type { EmployeeFeriasDto, EmployeeFeriasInput, EmployeeFeriasListItem } from './types';

export function createEmployeeFeriasApi(
  employeeId: number,
): CrudApi<EmployeeFeriasListItem, EmployeeFeriasDto, EmployeeFeriasInput, string> {
  const BASE = `/v1/employees/${employeeId}/ferias`;

  return {
    async list(query: DataTableQuery): Promise<ListEnvelope<EmployeeFeriasListItem>> {
      const { data } = await api.get<{
        data: Omit<EmployeeFeriasListItem, 'id'>[];
        meta: { total: number; pagina?: number; porPagina?: number };
      }>(BASE, { params: toGenexusParams(query) });
      const normalized = normalizeListEnvelope(data);
      return {
        ...normalized,
        data: normalized.data.map((r) => ({ ...r, id: r.dataInicio })),
      };
    },

    async get(dataInicio: string): Promise<EmployeeFeriasDto> {
      const { data } = await api.get<{ data: EmployeeFeriasDto }>(`${BASE}/${dataInicio}`);
      return data.data;
    },

    async create(input: EmployeeFeriasInput): Promise<EmployeeFeriasDto> {
      const { data } = await api.post<{ data: EmployeeFeriasDto }>(BASE, input);
      return data.data;
    },

    async update(dataInicio: string, input: EmployeeFeriasInput): Promise<EmployeeFeriasDto> {
      const { data } = await api.put<{ data: EmployeeFeriasDto }>(`${BASE}/${dataInicio}`, input);
      return data.data;
    },

    async remove(dataInicio: string): Promise<void> {
      await api.delete(`${BASE}/${dataInicio}`);
    },
  };
}
